"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageTwoTone = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ImageTwoTone = function ImageTwoTone() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    fill: "currentColor"
  }, react_1.default.createElement("path", {
    opacity: ".72",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2.667A2.667 2.667 0 0 0 21.333 0H2.667A2.667 2.667 0 0 0 0 2.667v15.338l3.027-4.044.008-.01a3.42 3.42 0 0 1 5.43 0l.014.018.915 1.242 3.455-4.34a3.4 3.4 0 0 1 5.302 0L24 18.165V2.667Zm-.081 19.323c-.038-.103-.09-.2-.159-.287l-7.48-9.33a1 1 0 0 0-1.56 0l-4.58 5.754a1 1 0 0 1-1.58 0l-2-2.717a1.02 1.02 0 0 0-1.62 0L.2 21.743a1.017 1.017 0 0 0-.125.222A2.668 2.668 0 0 0 2.667 24h18.666a2.668 2.668 0 0 0 2.586-2.01ZM6 3.6a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8Z"
  }), react_1.default.createElement("path", {
    opacity: ".72",
    d: "M24 23.001A1 1 0 0 1 23 24H1a1 1 0 0 1-1-.999v-.659c.001-.216.071-.426.2-.6l4.74-6.332a1.02 1.02 0 0 1 1.62 0l2 2.717a1 1 0 0 0 1.58 0l4.58-5.753a1 1 0 0 1 1.56 0l7.48 9.329c.143.182.22.407.22.639l.02.66Z"
  })));
};

exports.ImageTwoTone = ImageTwoTone;